import { AbstractControl, ValidationErrors } from "@angular/forms";

export const VerificaEmail = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || "";

  if (!value) {
    return null;
  }

  // Expressão regular para validar email
  let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(value)) {
    return { checkEmail: `Endereço de email inválido` };
  }

  return null;
};
